import React, { useEffect, useState } from 'react';
import { Table, Button, Space, Popconfirm, message } from 'antd';
import {
    EditOutlined, DeleteOutlined, PlusOutlined, CheckCircleOutlined, StopOutlined, UnorderedListOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {API_BASE_URL} from "../../config";

const SatCollections = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setLoading(true);
        axios
            .get(`${API_BASE_URL}/api/SatCollection`)
            .then((response) => {
                setData(response.data);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                message.error('Failed to load collections');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleDelete = async (id) => {
        try {
            console.log(`Deleting collection with ID: ${id}`);

            const response = await axios.delete(`${API_BASE_URL}/api/SatCollection/${id}`, {
                headers: { 'Accept': 'text/plain' },
            });

            console.log('Delete response:', response);

            if (response.status === 200 || response.status === 204) {
                message.success('Collection deleted successfully');
                fetchData();
            } else {
                message.error(`Failed to delete collection, status: ${response.status}`);
            }
        } catch (error) {
            console.error('Delete error:', error.response?.data || error.message);
            message.error(error.response?.data || 'Failed to delete collection');
        }
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            filterSearch: true,
            onFilter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
        },
        {
            title: 'Price (UZS)',
            dataIndex: 'price',
            key: 'price',
            render: (price) => `UZS ${price.toLocaleString()}`,
        },
        {
            title: 'Limit (max)',
            dataIndex: 'limit',
            key: 'limit',
        },
        {
            title: 'Status',
            dataIndex: 'active',
            key: 'active',
            render: (active) => active ? <CheckCircleOutlined style={{ color: 'green' }} /> : <StopOutlined style={{ color: 'red' }} />,
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Button type="link" icon={<UnorderedListOutlined />} onClick={() => navigate(`/sat-collection/${record.id}/questions`)}>
                        Questions
                    </Button>
                    <Button type="link" icon={<EditOutlined />} onClick={() => navigate(`/sat-collections/edit/${record.id}`)}>
                        Edit
                    </Button>
                    <Popconfirm
                        title="Are you sure to delete this collection?"
                        onConfirm={() => handleDelete(record.id)}
                        okText="Yes"
                        cancelText="No"
                        placement="topRight"
                    >
                        <Button type="link" icon={<DeleteOutlined />} danger>
                            Delete
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <div>
            <h2>Collection List</h2>
            <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/sat-collections/add')} style={{ marginBottom: 16 }}>
                Add New
            </Button>
            <Table columns={columns} dataSource={data} rowKey="id" loading={loading} pagination={false} />
        </div>
    );
};

export default SatCollections;
